
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { Configuration, PacketDetails, SavedConfiguration, SystemSetting } from './configuration.model';
import { ActivatedRoute, Router } from '@angular/router';




@Injectable()
export class ConfigurationService{

    private pkurl = 'api/package';
    private courl = 'api/configuration';
    private settingsurl = 'api/SystemSettings';
    packageId: number;
    public config: Configuration[];

    constructor(private http: Http, private router: Router, private httpclient: HttpClient) { }

    createPackage(packageName: string, packetTypeName: string, packetQueueCategory: string, priorityValue: number, configurations: Configuration[], state: string): Observable<PacketDetails> {
        return this.httpclient.post<PacketDetails>(this.pkurl, {PacketName: packageName,
            GroupBy: packetTypeName, PacketQueueCategory: packetQueueCategory, Priority: priorityValue, Configuration: configurations, state: state });
    }

    getPackageName(packageId: number, state: string): Observable<PacketDetails> {
        return this.httpclient.get<PacketDetails>(`${this.pkurl}/getpackage?packageId=${packageId}&state=${state}`);
    }
    createConfig(config: Configuration, state: string): Observable<SavedConfiguration[]> {
        return this.httpclient.post<SavedConfiguration[]>(`${this.courl}?state=${state}`, config);
    }

    getConfigs(id: number, state: string): Observable<SavedConfiguration[]> {
        return this.http.get(`${this.courl}/getpacketbyid?id=${id}&state=${state}`).pipe(map(res => res.json()));
    }

    getPackages(state: string): Observable<PacketDetails[]>{
        return this.httpclient.get<PacketDetails[]>(`${this.pkurl}/getall?state=${state}`);
    }

    inActivatePacket(id: number, state: string): Observable<any> {
        return this.http.put(`${this.pkurl}/inactivatepacket?id=${id}&state=${state}`, null);
    }

    updateConfiguration(configuration: SavedConfiguration, state: string): Observable<any>{
        return this.http.put(`${this.courl}/updateconfiguration?state=${state}`, configuration);
    }

    resetPacket(id: number, state: string): Observable<any> {
        return this.http.put(`${this.pkurl}/resetpacket?id=${id}&state=${state}`, null);
    }

    addConfig(config: Configuration, state: string): Observable<SavedConfiguration[]> {
        return this.httpclient.post<SavedConfiguration[]>(`${this.courl}/addconfiguration?state=${state}`, config);
    }

    editPacket(packetId: number, packetname: string, priority: string, state: string): Observable<any>{
        return this.http.put(`${this.pkurl}/editpacket?Packetid=${packetId}&PacketName=${packetname}&Priority=${priority}&state=${state}`, null);
    }

    getUserPacketStats(packetId: number, state: string): Observable<any> {
        return this.http.get(`${this.pkurl}/userpacketstats/?packetId=${packetId}&state=${state}`);
    }

    getUserPackets(packetId: number, state: string, isComplete?: boolean): Observable<any> {
        return this.http.get(`${this.pkurl}/userpackets/?packetId=${packetId}&state=${state}${isComplete?'':'&isComplete=false'}`);
    }

    getPacketQAdTicketCountsOfThisMonth(packetId: number, state: string): Observable<any> {
        return this.http.get(`${this.pkurl}/userpacketmonthlycounts/?packetId=${packetId}&state=${state}`);
    }

    getPacketDeductionCountsOfThisMonth(packetId: number, state: string): Observable<any> {
        return this.http.get(`${this.pkurl}/packetdeductioncounts/?packetId=${packetId}&state=${state}`);
    }
}
